/**
 * Sudoku-pencilmarks motion vocabulary.
 *
 * The aesthetic is "real pencil on real paper" — organic, slightly imperfect.
 * Springs are loose with longer settle than the Reading Room. Animations
 * deliberately wobble.
 */

import { easing, timings } from '@/juice';

/** Page entrance spring — the notebook opens. */
export const pageSpring = {
  type: 'spring' as const,
  stiffness: 180,
  damping: 22,
  mass: 1.1,
};

/** Card spring used on hub tiles + difficulty tiles. */
export const cardSpring = {
  type: 'spring' as const,
  stiffness: 210,
  damping: 24,
  mass: 0.9,
};

/** Tighter spring for hover lifts. */
export const hoverSpring = {
  type: 'spring' as const,
  stiffness: 320,
  damping: 22,
};

/** Number-placement spring — slight overshoot to read as a real hand-place. */
export const placeSpring = {
  type: 'spring' as const,
  stiffness: 380,
  damping: 14,
  mass: 0.7,
};

/** Candidate-mark fade-in spring (quick). */
export const candidateSpring = {
  type: 'spring' as const,
  stiffness: 420,
  damping: 26,
};

/** Stagger between consecutive hub tiles. */
export const HUB_STAGGER_S = 0.08;

/** Time we let the eraser smudge linger before fading (ms). */
export const SMUDGE_LINGER_MS = 600;

/** Cell-selection rectangle draws in ~280ms via SVG stroke-dasharray. */
export const SELECTION_DRAW_MS = 280;

/** Completion-flourish SVG-stroke draw duration (ms). */
export const FLOURISH_DRAW_MS = 1100;

export { easing, timings };
